import { render, staticRenderFns } from "./SecurityProfile.vue?vue&type=template&id=a6ca2738"
import script from "./SecurityProfile.vue?vue&type=script&lang=js"
export * from "./SecurityProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports